<template>
  <RouterView></RouterView>
</template>

<script setup lang="ts"></script>
